import { DashboardJobsStatus, IDashboardJob } from '~/domain/DashboardJobs';
import history from '../../../../../history';
import { headerScheduledTabTitles } from '../../utils';
import { CustomTable } from '../CustomTable';
import { renderRow } from './renderRow';

export const ScheduledTabLegacy = () => {
  const handleOnClick = (item: IDashboardJob) => {
    history.push(`/dashboard/job/${item.id}/details`);
  };

  return (
    <CustomTable
      type={DashboardJobsStatus.FILLED}
      renderRow={(item) => renderRow({ item, handleOnClick })}
      headerTitles={headerScheduledTabTitles}
      onRowClick={(item) => handleOnClick(item)}
    />
  );
};
